export enum InformationAvailabilityType {
  None = 'None',
  FromOne = 'FromOne',
  FromBoth = 'FromBoth'
}
